import React from "react";
import Select from "react-select";
import { Label } from "office-ui-fabric-react/lib/Label";

const options = [
  { label: "Admin", value: "admin" },
  { label: "Seller", value: "seller" },
  { label: "Buyer", value: "buyer" },
  { label: "Shipper", value: "shipper" }
];

const RoleSelect = props => {
  const { name, value, label, placeholder, touched, error } = props;

  return (
    <div>
      <Label>{label}</Label>
      <Select
        options={options}
        onChange={value => props.onChange(name, value)}
        onBlur={() => props.onBlur(name, true)}
        value={value}
        placeholder={placeholder}
        simpleValue
      />
      {!!error && touched && <div className="error-message">{error}</div>}
    </div>
  );
};

export default RoleSelect;



// WEBPACK FOOTER //
// ./src/common/Dropdowns/_RoleSelect.js